// @core/api/endpoints/landing/duplicate_landing_page.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DuplicateLandingPageRequest,
  LandingPageResponse,
} from '../../../types/landing';

const BASE_PATH = '/landing';

/**
 * Duplicate landing page
 * Creates a copy of a page with all sections. The copy is created in draft status.
 */
export async function DuplicateLandingPage(
  page_id: string,
  data: DuplicateLandingPageRequest,
  options?: RequestOptions
): Promise<LandingPageResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/landing/pages/:page_id/duplicate`;
  requestPath = requestPath.replace(':page_id', encodeURIComponent(page_id));
  const requestOptions = options;
  return client.post<LandingPageResponse>(requestPath, data, requestOptions);
}
